module.exports = __webpack_public_path__ + "img/index_dowm_01.32a22dc6.png";